import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type SocietyProfileParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]";
import { type NotificationSubscriptionBodyInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/notifications/subscription";
import { type NotificationSubscriptionView } from "shared/mappers/database/notification/notification-subscription";
export const postSocietyProfileNotificationsSubscriptionContract: BaseApiContract<
  SocietyProfileParamsInput,
  NotificationSubscriptionBodyInput,
  NotificationSubscriptionView
> = {
  method: HttpMethod.POST,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/notifications/subscription",
  paramsType: {} as SocietyProfileParamsInput,
  bodyType: {} as NotificationSubscriptionBodyInput,
  responseType: {} as NotificationSubscriptionView,
};
